<script>
import { mapActions } from 'vuex'
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";

/**
 * Advanced Table component
 */
export default {
  page: {
    title: "Home",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Home",
      items: []
    }
  },
  watch: { },
  mounted() {
    this.getAccess();
  },
  created() { },
  methods: {
    getAccess() {
      let userdata = JSON.parse(localStorage.getItem('user'));
      if (userdata.userdata.role.name != 'superadmin') {
        this.$router.push({ name: 'mobile' });
      } else {
        this.$router.push({ name: 'admin' });
      }
    },
  },
  middleware: "router-auth",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>
